export default __webpack_public_path__ + "static/media/id-billing-logotype-l.ca874e5d.svg";